module.exports = __webpack_public_path__ + "static/book_03-960x550-2ee33517cf4ceb49a37849d9181aecf8.jpg";